import type { Tyre } from "models";

export const getTyreDescription = (tyre?: Tyre) => {
  if (!tyre) return "";

  return !tyre.description.includes(`${tyre.carry_capacity}/${tyre.speed}`) && !tyre.description.includes(`${tyre.carry_capacity}${tyre.speed}`)
    ? `${tyre.description} ${tyre.carry_capacity}${tyre.speed}`
    : tyre.description;
};

const normalizeTyreDescription = (tyre: Tyre) => {
  const carryCapacitySpeed = `${tyre.carry_capacity}${tyre.speed}`;
  const widthHeight = `${tyre.width}/${tyre.height}`;

  if (!tyre.description.includes(widthHeight)) return `${widthHeight} R${tyre.size} ${tyre.description} ${carryCapacitySpeed}`;

  const modelName = tyre.description
    .split(" ")
    .filter(t => {
      return (
        t.toLowerCase() !== tyre.manufacturer.toLowerCase() &&
        !t.includes(widthHeight) &&
        !t.includes(`R${tyre.size}`) &&
        !t.includes(carryCapacitySpeed) &&
        !t.includes(`${tyre.carry_capacity}/`)
      );
    })
    .join(" ");

  if (modelName) return `${widthHeight} R${tyre.size} ${modelName} ${carryCapacitySpeed}`;
  return `${widthHeight} R${tyre.size} ${carryCapacitySpeed}`;
};

export const getFullTyreDescription = (tyre?: Tyre, isTyreNet?: boolean) => {
  if (!tyre) return "";
  if (isTyreNet) return normalizeTyreDescription(tyre);
  return getTyreDescription(tyre);
};

export const getTyreSize = (tyre?: Tyre) => {
  if (!tyre) return "";
  return `${tyre.width}-${tyre.height}-R${tyre.size}`;
};
